import { useQuery } from "./useQuery";
import { getStrategyReturns } from "services";

export const useStrategyReturns = (strategyId, options = {}) => {
  return useQuery({
    queryKey: ["strategy-returns", strategyId],
    queryFn: () => getStrategyReturns(strategyId),
    enabled: !!strategyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    ...options,
  });
};
